import { useCallback, useState } from "react";
import { useStores } from "stores/setup/use-store";

export function useAlertEditUsers() {
  const {
    dataStores: { insightAlertStore },
  } = useStores();

  const [usersTableSelected, setUsersTableSelected] = useState<React.Key[]>([]);

  const clearUserTableSelected = useCallback(() => {
    setUsersTableSelected([]);
    insightAlertStore.setOperationRuleAlertUserSelected([]);
  }, [insightAlertStore]);

  const updateUsersTableSelected = useCallback((selectedKeys: React.Key[]) => {
    setUsersTableSelected(selectedKeys);
  }, []);

  return {
    usersTableSelected,
    setUsersTableSelected: updateUsersTableSelected,
    clearUserTableSelected,
    alertUsers: insightAlertStore.operationRuleAlertUser,
  };
}
